import React, { Dispatch, memo, RefObject, SetStateAction, useEffect, useRef, useState } from 'react'
import { toTitleCase } from '../../../../Utils/Texts/toTitleCase';
import { truncateString } from '../../../../Utils/commonFunctions';
import { user_mstr_modal } from '../../../../ReduxTool/Slice/Auth/types';
import { Button } from '../../../Button';
import { ArrowRightIcon, ChangePasswordIcon, CreditCardIcon, HelpNewIcon, IconSettings, LanguageIcon, LogOutIcon, NotificationsIcon, ProfileUpdateIcon, SupportIocn } from '../../../../assests/icons/Icons';
import { ModalHeaderFooter, ProfileModalType } from '../../../../Containers/DefaultLayouts/DefaultHeader';
import { useAppDispatch } from '../../../../ReduxTool/store/hooks';
import { setModalHeaderFooter } from '../../../../ReduxTool/Slice/CommonReducers/CommonReducers';
import { store } from '../../../../ReduxTool/store/store';
import { getModalConfig, ProfileOptionsModalType } from './Const';

interface Uname { fname: string; lname: string; }

interface ProfileModalTy {
  profileimage: any;
  openViewProfileModal: (modalName: ProfileModalType) => void;
  user: user_mstr_modal;
  logout: (e:any) => void;
  uname: Uname;
  profileContainerRef: RefObject<HTMLDivElement>;
}

// ── Sub-modal props: adds hover handlers so the panel stays open ──
interface ProfileOptionsProps {
  onClose: () => void;
  toggleRef: RefObject<HTMLDivElement>;
}

interface HelpOptionsProps extends ProfileOptionsProps {
  openViewProfileModal: (modalName: ProfileModalType) => void;
}

const handleProfileOptionsModal = (modalTy: ProfileOptionsModalType | null) => {
  store.dispatch(setModalHeaderFooter(getModalConfig(modalTy)));
};

// ─────────────────────────────────────────────────────────────
const ProfileOptions = ({ onClose, toggleRef }: ProfileOptionsProps) => {
  const subModalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        subModalRef.current && !subModalRef.current.contains(event.target as Node) &&
        toggleRef.current && !toggleRef.current.contains(event.target as Node)
      ) { onClose(); }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose, toggleRef]);

  return (
    <div ref={subModalRef} className="absolute z-50 right-[calc(100%-2px)] top-[25%] w-max pr-[15px] cursor-default">
      <div className="w-[264px] max-h-[72vh] overflow-x-auto rounded-2xl border border-gray-300 bg-white p-3 py-6 select-none custom-scrollbar-css shadow-lg">
        <div className='w-full flex flex-col justify-center'>
          <div className="profile-heading uppercase heading-10-inter-regular leading-5 px-3 pb-1">Profile</div>
          <span onClick={(e) => { e.stopPropagation(); handleProfileOptionsModal(ProfileOptionsModalType.Security); onClose(); }} className="btn-sm-more flex-row justify-start items-center gap-3 px-3 py-2 heading-14-inter-normal cursor-pointer hover:bg-gray-200/60 rounded-md">Security</span>
          <span onClick={(e) => { e.stopPropagation(); handleProfileOptionsModal(ProfileOptionsModalType.UserAccount); onClose(); }} className="btn-sm-more flex-row justify-start items-center gap-3 px-3 py-2 heading-14-inter-normal cursor-pointer hover:bg-gray-200/60 rounded-md">Account information</span>
        </div>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────────
const HelpOptions = ({ onClose, toggleRef, openViewProfileModal }: HelpOptionsProps) => {
  const subModalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if ( subModalRef.current && !subModalRef.current.contains(event.target as Node) && toggleRef.current && !toggleRef.current.contains(event.target as Node) )
         { onClose(); }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose, toggleRef]);

  return (
    <div ref={subModalRef} className="absolute z-50 right-[calc(100%-2px)] -bottom-[8%] w-max pr-[15px] cursor-default">
      <div className="w-[264px] max-h-[72vh] overflow-x-auto rounded-2xl border border-gray-300 bg-white p-3 py-6 select-none custom-scrollbar-css shadow-lg">
        <div className='w-full flex flex-col justify-center'>
          <div className="profile-heading uppercase heading-10-inter-regular leading-5 px-3 pb-1">Help</div>
          <span onClick={(e) => { e.stopPropagation(); onClose(); openViewProfileModal("supporttrack"); }} className="btn-sm-more flex-row justify-start items-center gap-3 px-3 py-2 heading-14-inter-normal cursor-pointer hover:bg-gray-200/60 rounded-md">My tickets</span>
          {/* <span onClick={(e) => { e.stopPropagation(); onClose(); }} className="btn-sm-more flex-row justify-start items-center gap-3 px-3 py-2 heading-14-inter-normal cursor-default hover:bg-gray-200/60\ rounded-md">Help center</span> */}
          <span onClick={(e) => { e.stopPropagation(); onClose(); openViewProfileModal("support"); }} className="btn-sm-more flex-row justify-start items-center gap-3 px-3 py-2 heading-14-inter-normal cursor-pointer hover:bg-gray-200/60 rounded-md">Contact support</span>
        </div>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────
const enum SubProfileModal {
  Profile = "profile",
  Help    = "help",
  None    = "none",
}

type ProfileSubModalType = `${SubProfileModal}` | null;

// ─────────────────────────────────────────────────────────────
const ProfileOptionModal = ({ profileContainerRef, profileimage, openViewProfileModal, user, logout, uname }: ProfileModalTy) => {
  const dispatch = useAppDispatch();

  const HandleLogout = (e:any)=>{
     dispatch(setModalHeaderFooter({title: "", btnTxt: "", secondaryBtnTxt: "", isheader: false,modalid: "" }));
    logout(e)
  }

  const [optionsModal, setOptionsModal] = useState({ profile: false, help: false });
  const profileToggleRef = useRef<HTMLDivElement>(null);
  const helpToggleRef    = useRef<HTMLDivElement>(null);

  const handleSubModal = (modalName: ProfileSubModalType) => {
    setOptionsModal({ profile: modalName === "profile", help: modalName === "help" });
  };

  return (
    <div ref={profileContainerRef} className="absolute right-[8px] px-3 py-6 rounded-2xl top-[calc(100%+4px)] w-[344px] border border-gray-300 overflow-x-auto max-h-[72vh] bg-white select-none custom-scrollbar-css shadow-lg !overflow-visible">

      {/* MANAGE ACCOUNT */}
      <div ref={profileToggleRef} className="profile-header relative cursor-pointer" onMouseEnter={() => handleSubModal("profile")} onClick={() => handleSubModal("profile")} onMouseLeave={() => handleSubModal(null)}>
        <div className="profile-heading uppercase heading-10-inter-regular leading-5 px-3">MANAGE ACCOUNT</div>
        <div className='py-1 pb-4 flex gap-3 justify-between items-center px-3'>
          <div className='relative'>
            {profileimage.size !== 0 && profileimage !== "" ? (
              <img src={URL.createObjectURL(profileimage)} alt="Selected" style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "5vh", height: "5vh", borderRadius: "100%" }} />
            ) : (
              <span className="inline-flex items-center justify-center size-10 heading-12-inter-medium-white rounded-full border-[0.3vh] border-[rgba(217,217,217,1)] bg-custom-primary-dark text-white shadow-sm uppercase">{uname && uname.fname + uname.lname}</span>
            )}
            {/* <span className='absolute text-[10px] left-1/2 -translate-x-1/2 text-nowrap px-1 leading-tight rounded-md bottom-0 text-custom-primary-dark bg-[rgba(217,217,217,1)]'>Pro</span> */}
          </div>
          <div className='profile-user_info flex-1 w-full min-w-0'>
            <h2 className='heading-18-inter-medium truncate'>{toTitleCase(user.fname) + " " + toTitleCase(user?.lname ?? "")}</h2>
            <p className="heading-10-inter-regular leading-6">{truncateString(user.emailid ?? "", 40)}</p>
          </div>
          <span className="w-3 mr-2"><ArrowRightIcon className='size-5' /></span>
        </div>
        {optionsModal.profile && (<ProfileOptions toggleRef={profileToggleRef} onClose={() => handleSubModal(null)} />)}
      </div>

      <div className="divider border-b mx-3"></div>

      {/* PREFERENCES */}
      <div className='w-full flex flex-col justify-center py-2'>
        <div className="profile-heading uppercase heading-10-inter-regular leading-5 pl-4">PREFERENCES</div>
        <span onClick={() => handleProfileOptionsModal(ProfileOptionsModalType.Units)} className="btn-sm-more flex-row justify-start items-center gap-3 py-2 heading-14-inter-normal"><IconSettings className='size-4' /> Units & region</span>
        {/* <span onClick={() => openViewProfileModal("notification")} className="btn-sm-more cursor-default flex-row justify-start items-center gap-3 py-2 heading-14-inter-normal"><NotificationsIcon className='size-4' /> Notification</span> */}
        <span onClick={() => handleProfileOptionsModal(ProfileOptionsModalType.Language)} className="btn-sm-more flex-row justify-start items-center gap-3 py-2 heading-14-inter-normal"><LanguageIcon className='size-4' /> Language (English)</span>
      </div>

      <div className="divider border-b mx-3"></div>

      {/* HELP & BILLING */}
      <div className='relative w-full flex flex-col justify-center py-2' onMouseLeave={() => handleSubModal(null)}>
        <div className="profile-heading uppercase heading-10-inter-regular leading-5 pl-4">HELP & BILLING</div>

        <span onClick={() => handleProfileOptionsModal(ProfileOptionsModalType.BillingPlans)} className="btn-sm-more flex-row justify-start items-center gap-3 py-2 heading-14-inter-normal"><CreditCardIcon className='size-4' /> Subscription & billing</span>

        <div ref={helpToggleRef} onMouseEnter={() => handleSubModal("help")} onClick={() => handleSubModal("help")} className="btn-sm-more flex-row justify-between items-center gap-3 py-2 heading-14-inter-normal"  >
          <span className='flex items-center gap-2'><HelpNewIcon className='size-4' /> Help and resources</span>
          <ArrowRightIcon className='size-5' />
        </div>

        {optionsModal.help && (<HelpOptions toggleRef={helpToggleRef} onClose={() => handleSubModal(null)} openViewProfileModal={openViewProfileModal} />
        )}
      </div>

      <div className="divider border-b mx-3"></div>

      {/* LOGOUT */}
      <div className="para-sm py-2 text-gray-800 cursor-pointer flex justify-center items-center w-full">
        <div onClick={HandleLogout} className="btn-sm-more flex-row justify-between items-center gap-3 py-2 heading-14-inter-normal">
          <span className='flex items-center gap-2'><LogOutIcon className='size-4' /> Log out</span>
        </div>
      </div>

      <div className='flex justify-center items-center heading-10-inter-medium'>
        Privacy Policy<span className='size-0.5 rounded-full bg-custom-primary-dark mx-1'></span>Terms of Use
      </div>

    </div>
  );
};

export default memo(ProfileOptionModal);
